<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
	data() {
		return {

		}
	},
	computed: {
	},
	mounted() {
	},
	methods: {
	}
}
</script>

<style lang="scss">
</style>
